import { useEffect } from "react";
import BusinessCard from "../components/BusinessCard";

const yano = {
  name: "Yano Bussels",
  role: "Co-Founder",
  phone: "+32 473 24 83 85",
  phoneWa: "32473248385",
  email: "yano@jynova.be",
  website: "www.jynova.be",
  photo: "/yano.webp",
  vcf: "/yano.vcf",
};

export default function Yano() {
  useEffect(() => {
    document.title = "Yano Bussels — JYNOVA";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute(
      "content",
      "Digitale visitekaart van Yano Bussels — Co-Founder bij JYNOVA. Bel, mail of bewaar het contact direct."
    );
  }, []);
  return <BusinessCard person={yano} />;
}
